import { gql } from '@apollo/client'

export const PRICELIST_CORE_FRAGMENT = gql`
  fragment CoreData on PriceList {
    id
    createdAt
    updatedAt
    default
    name
  }
`

export const GET_PRICELIST_DETAILS = gql`
  ${PRICELIST_CORE_FRAGMENT}
  query GET_PRICELIST($id: Int!) {
    findUniquePriceList(where: { id: $id }) {
      ...CoreData
    }
  }
`

export const DELETE_MANY_PRICELISTS = gql`
  mutation DELETE_PRICELISTS($ids: [Int!]!) {
    deleteManyPriceList(where: { id: { in: $ids } }) {
      count
    }
  }
`

export const GET_PRICELIST = gql`
  query GET_PRICELIST($id: Int!) {
    findUniquePriceList(where: { id: $id }) {
      id
      createdAt
      updatedAt
      default
      name
    }
  }
`
export const GET_PRICELIST_PRODUCTS = gql`
  query GET_PRODUCTS($id: Int, $language: Language, $take: Int, $skip: Int) {
    findManyProductContainerCount(
      where: {
        advanced_product: {
          is: {
            OR: [
              { base_prices: { some: { price_listId: { equals: $id } } } }
              {
                advanced_product_price_fabric_category: {
                  some: { price_listId: { equals: $id } }
                }
              }
              {
                sofa_forms: {
                  some: {
                    form_price_fabric_category: {
                      some: { price_listId: { equals: $id } }
                    }
                  }
                }
              }
              {
                additional_component_to_advanced_product: {
                  some: {
                    price_fabric_category: {
                      some: { price_listId: { equals: $id } }
                    }
                  }
                }
              }
              {
                additional_component_to_advanced_product: {
                  some: {
                    extra_prices: { some: { price_listId: { equals: $id } } }
                  }
                }
              }
            ]
          }
        }
      }
    )
    findManyProductContainer(
      where: {
        advanced_product: {
          is: {
            OR: [
              { base_prices: { some: { price_listId: { equals: $id } } } }
              {
                advanced_product_price_fabric_category: {
                  some: { price_listId: { equals: $id } }
                }
              }
              {
                sofa_forms: {
                  some: {
                    form_price_fabric_category: {
                      some: { price_listId: { equals: $id } }
                    }
                  }
                }
              }
              {
                additional_component_to_advanced_product: {
                  some: {
                    price_fabric_category: {
                      some: { price_listId: { equals: $id } }
                    }
                  }
                }
              }
              {
                additional_component_to_advanced_product: {
                  some: {
                    extra_prices: { some: { price_listId: { equals: $id } } }
                  }
                }
              }
            ]
          }
        }
      }
      take: $take
      skip: $skip
    ) {
      id
      type
      single_product {
        product_profiles(where: { language: { equals: $language } }) {
          name
        }
      }
      advanced_product {
        id
        advanced_product_type
        advanced_product_profiles(where: { language: { equals: $language } }) {
          name
        }
        base_prices(where: { price_listId: { equals: $id } }) {
          price
          price_from
          price_listId
        }
        advanced_product_price_fabric_category(
          where: { price_listId: { equals: $id } }
        ) {
          price
          price_listId
          fabrice_price_category {
            group_number
          }
        }
        sofa_forms {
          id
          name
          code
          form_price_fabric_category(where: { price_listId: { equals: $id } }) {
            price
            price_listId
            fabrice_price_category {
              group_number
            }
          }
        }
      }
    }
  }
`

export const GET_PRICELIST_SOFA_MODULES = gql`
  query GET_PRICELIST_SOFA_MODULES(
    $id: Int!
    $take: Int
    $skip: Int
    $advancedProductId: Int
    $orderBy: [SofaFormOrderByWithRelationInput!]
  ) {
    findManySofaFormCount(
      where: {
        AND: [
          {
            form_price_fabric_category: {
              some: { price_listId: { equals: $id } }
            }
          }
          { advanced_product: { is: { id: { equals: $advancedProductId } } } }
        ]
      }
    )
    findManySofaForm(
      where: {
        AND: [
          {
            form_price_fabric_category: {
              some: { price_listId: { equals: $id } }
            }
          }
          { advanced_product: { is: { id: { equals: $advancedProductId } } } }
        ]
      }
      take: $take
      skip: $skip
      orderBy: $orderBy
    ) {
      id
      code
      name
      form_price_fabric_category(where: { price_listId: { equals: $id } }) {
        price
        price_listId
        fabrice_price_category {
          group_number
        }
      }
    }
  }
`

export const GET_PRICELIST_COMPONENTS = gql`
  query GET_PRICELIST_COMPONENTS($id: Int!, $advancedProductId: Int) {
    findManyAdditionalComponentToAdvancedProduct(
      where: {
        AND: [
          { advanced_product: { is: { id: { equals: $advancedProductId } } } }
          {
            OR: [
              {
                price_fabric_category: {
                  some: { price_listId: { equals: $id } }
                }
              }
              { extra_prices: { some: { price_listId: { equals: $id } } } }
            ]
          }
        ]
      }
    ) {
      additional_component {
        id
        code
        additional_component_profiles {
          name
        }
      }
      extra_prices(where: { price_listId: { equals: $id } }) {
        price
      }
      price_fabric_category(where: { price_listId: { equals: $id } }) {
        price
        fabrice_price_category {
          group_number
        }
      }
    }
  }
`

export const GET_PRICELISTS = gql`
  query GET_PRICELISTS(
    $searchTerm: String
    $take: Int
    $skip: Int
    $orderBy: [PriceListOrderByWithRelationInput!]
  ) {
    findManyPriceListCount(
      where: { name: { mode: insensitive, contains: $searchTerm } }
    )

    findManyPriceList(
      orderBy: $orderBy
      where: { name: { mode: insensitive, contains: $searchTerm } }
      take: $take
      skip: $skip
    ) {
      id
      name
      createdAt
      updatedAt
    }
  }
`
